import { Box, Typography, useMediaQuery, useTheme } from "@material-ui/core"
import { AddCircle } from "@material-ui/icons"
import { PropTypes } from "prop-types"
import React, { useContext } from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import DarkButton from "~/components/Common/DarkButton"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import ClientContext from "~/contexts/Client"
import AddCourseDialogGeneric from "~/dialogs/AddCourseDialogGeneric"
import AddCourseCard from "~/dialogs/AddCourseDialogGeneric/CourseCard"
import useStyles from "./styles"

function DashboardCourse({ course, addedCourses, setAddedCourses, index }) {
  return (
    <Draggable draggableId={course.id.toString()} index={index}>
      {(provided) => {
        return (
          <AddCourseCard
            course={course}
            type="view"
            index={index}
            addedCourses={addedCourses}
            setAddedCourses={setAddedCourses}
            provided={provided}
          />
        )
      }}
    </Draggable>
  )
}

DashboardCourse.propTypes = {
  course: PropTypes.object,
  index: PropTypes.number,
  addedCourses: PropTypes.array,
  setAddedCourses: PropTypes.func,
}

const DashboardCourseList = React.memo(function DashboardCourseList({
  courses,
  setAddedCourses,
}) {
  return courses?.map((course, index) => (
    <DashboardCourse
      course={course}
      type="view"
      index={index}
      key={course.id}
      addedCourses={courses}
      setAddedCourses={setAddedCourses}
    />
  ))
})

DashboardCourseList.propTypes = {
  courses: PropTypes.array,
  setAddedCourses: PropTypes.func,
}

const DashboardCourses = ({ reorder }) => {
  const classes = useStyles()
  const theme = useTheme()
  const phoneView = useMediaQuery(theme.breakpoints.down("sm"))
  const { dashboardCourses, setDashboardCourses } = useContext(ClientContext)
  const { openDialog } = useContext(AppContext)

  function onDashboardCoursesDragEnd(result) {
    if (!result.destination) {
      return
    }

    if (result.destination.index === result.source.index) {
      return
    }

    const orderedDashboardCourses = reorder(
      dashboardCourses,
      result.source.index,
      result.destination.index,
    )

    setDashboardCourses(orderedDashboardCourses)
  }

  const addDashboardCourses = async () => {
    const newCourses = await openDialog(
      "addCourseDialogGeneric",
      dashboardCourses,
    )
    if (newCourses !== null) {
      setDashboardCourses(newCourses)
    }
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="10px"
        width="100%"
        zIndex={10}
      >
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          <Typography
            variant="h3"
            color="primary"
            style={{ fontWeight: "700", marginRight: "8px" }}
          >
            Client Courses
          </Typography>
          <Typography
            variant="h3"
            color="primary"
            className={classes.orderText}
          >
            In order as they appear
          </Typography>
        </Box>
        <PermissionsWrapper permissionGroup="admin">
          <DarkButton
            onClick={addDashboardCourses}
            // style={path?.published ? { display: "none" } : null}
            startIcon={
              <AddCircle
                fontSize="small"
                classes={{ root: classes.addCircle }}
              />
            }
          >
            {phoneView ? "Add" : "Add Course"}
          </DarkButton>
        </PermissionsWrapper>
      </Box>
      <Box paddingBottom="32px" position="relative">
        {dashboardCourses?.length > 0 ? (
          <DragDropContext onDragEnd={onDashboardCoursesDragEnd}>
            <Droppable droppableId="course">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <DashboardCourseList
                    courses={dashboardCourses}
                    setAddedCourses={setDashboardCourses}
                  />
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        ) : null}
      </Box>
      <AddCourseDialogGeneric />
    </>
  )
}

DashboardCourses.propTypes = {
  reorder: PropTypes.func,
}

export default DashboardCourses
